import { localization } from '@ocean/configs'
import { Locale } from '@ocean/configs/dist'
import { ModuleLocalization } from '@ocean/configs/dist/localization'
import * as modulesLocalization from './'

const { i18n, DEFAULT_LOCALIZATION_NAMESPACE } = localization

export const initLocalization = (language: Locale, translations: Record<string, string | any>) => {
  const modulesLocalizations: ModuleLocalization[] = Object.values(modulesLocalization)
  const localizations: Record<string, string | any> = modulesLocalizations.reduce(
    (acc: Record<string, string | any>, localization: ModuleLocalization) => {
      acc[localization.namespace] = localization[language]
      return acc
    },
    {}
  )
  // Add common language translations
  i18n.addResourceBundle(language, DEFAULT_LOCALIZATION_NAMESPACE, translations, true, true)

  // Add modules translation
  Object.keys(localizations).forEach(key => {
    i18n.addResourceBundle(language, key, localizations[key], true, true)
  })
}
